import * as React from "react"
import * as ReactDOM from "react-dom";

import {Modal} from "../../../lib/sbhtml/modal"
import {Field} from "../containers"
import {Form} from "../../../lib/sbhtml/form"
import {Input} from "../../../lib/sbhtml/input"
import {Company as Company_, CompanySelector} from "./companySelector"
import {DatePicker, DatePickerProps} from '../../../lib/sbhtml/datePicker'

export type Company = Company_

export type FieldLabels = {
	startDate: string,
	endDate: string,
	companyName: string,
	companyId: string,
	positionTitle: string,
	memberships: string
}

export type EmploymentHistoryPositionViewProps = {
	id: number,
	userId: number,
	startDate: Date,
	endDate: Date,
	companyName: string,
	companyId: number,
	positionTitle: string,
	isSaving: boolean,
	companies: Company[],
	labels: FieldLabels,
	datePickerProps: DatePickerProps,
	errorFields: Field[]|undefined,
	errorMsgs: string[]|undefined|null
}

export type CallbackProps = {
	positionTitleChanged:(newName:string) => void
	startDateChanged: (text: string, date: Date) => void
	endDateChanged: (text: string, date: Date) => void
	companyNameChanged: (newTitle:string) => void
	companyIdChanged: (selectorId: string, newCompany: Company|undefined) => void
	onClose:() => void
	onSave:() => void
}


const FormErrors = (props:{msgs: null|undefined|string[]}) => {
	if (!props.msgs || props.msgs.length == 0) {
		return <div></div>
	}

	let reactMsgList = props.msgs.map(function(msg, i) {
		return <FormError msg={msg} key={i}/>
	})

	return <div style={ {border: "solid red 2px", margin: "10px 3px 3px 3px" } } >{reactMsgList}</div>
}

const FormError = (props:{key: number, msg: string}) =>
	<div key={props.key}>{props.msg}</div>


const CurrentPositionForm = (props:EmploymentHistoryPositionViewProps & CallbackProps) => 
	<div><Modal isOpen={true} title="Employment History Position" onRequestClose={props.onClose} > 
		<div>You have selected the user's current position. It cannot be updated from here.</div>
	</Modal></div>

const PositionForm = (props:EmploymentHistoryPositionViewProps & CallbackProps) => 
	<div>
		<Form hasSave={true} hasCancel={true} onCancel={props.onClose} onSubmit={props.onSave} isSubmitting={props.isSaving}>
			<table><tbody>
				<tr><td>* {props.labels.startDate}</td><td><DatePicker 
					date={props.startDate} 
					buttonImage={props.datePickerProps.buttonImage } 
					onChange={(text, date) => props.startDateChanged(text, date)}
					invalid={props.errorFields != undefined && props.errorFields.indexOf('startDate') !== -1}
					readonly
				/></td></tr>
				<tr><td>* {props.labels.endDate}</td><td><DatePicker 
					date={props.endDate} 
					buttonImage={props.datePickerProps.buttonImage }
					onChange={(text, date) => props.endDateChanged(text, date)}
					invalid={props.errorFields != undefined && props.errorFields.indexOf('endDate') !== -1}
					readonly
				/></td></tr>
				<tr><td>* {props.labels.companyName}</td><td><Input 
					value={props.companyName} 
					onChange={(value) => props.companyNameChanged(value)} 
					invalid={props.errorFields != undefined && props.errorFields.indexOf('companyName') !== -1}
				/></td></tr>
				<tr><td>Select {props.labels.companyName}</td><td>
						<CompanySelector 
							selectorId={'employmentHistoryCompanySelector'} 
							selectedId={props.companyId} 
							companies={props.companies} 
							onSelectorChange={(selectorId, company) => props.companyIdChanged(selectorId, company)}
						/></td></tr>
				<tr><td>{props.labels.positionTitle}</td><td><Input value={props.positionTitle} onChange={(value) => props.positionTitleChanged(value)} /></td></tr>
			</tbody></table>
			<FormErrors msgs={props.errorMsgs}/>
		</Form>
	</div>
	
export const EmploymentHistoryPositionView = (props:EmploymentHistoryPositionViewProps & CallbackProps) => {

	if (props.id == -1 ) {
		return <CurrentPositionForm {...props} />;
	}

	return <div>
				<Modal isOpen={true} 
					title="Employment History Position" 
					onRequestClose={() => {
						setTimeout(props.onClose, 0) // put at end of event queue?
					}}
					style={{width: '400px'}} >
						<PositionForm {...props} />
				</Modal>
			</div>;
}



// WEBPACK FOOTER //
// ./src/contacts/employmentHistory/components/employmentHistoryView.tsx